export default __webpack_public_path__ + "static/media/user.10777912.svg";